import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import '../../Styles/Header.css'
import Appbar from '../../Component/NavPannel/Appbar';
import ActivityLayout from '../../Component/Layouts/ActivityLayout';


const mdTheme = createTheme();

function ActivityLogs() {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Activity Logs"/>
        < ActivityLayout/>
      </Box>
    </ThemeProvider>
  );
}

export default function index() {
  return <ActivityLogs />
}